import { Fragment } from 'react';

import useMeetContextView from './UseMeetContextView';

import NavLinks from './NavLinks';

import Headings from '@usas/ui-web/components/headings/Headings';
import LeftArrowIcon from '@usas/ui-web/components/icons/LeftArrowIcon';
import MobileContextBasedNav from '@usas/ui-web/components/contextBasedNav/MobileContextBasedNav';
import LargeContextBasedNav from '@usas/ui-web/components/contextBasedNav/LargeContextBasedNav';
import PageNotFound from '@usas/ui-web/components/PageNotFound';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import Constants from '@usas/ui-web/utils/Constants';
import { formatDate } from '@usas/ui-web/utils/DateFunctions';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const MeetContextView = ({ children }) => {
  const {
    meetState,
    meetCompetitionSummaryState,
    searchMeetState,
    backToLabel,
    onBackClicked,
    onHomeClicked
  }
    = useMeetContextView();

  if (!meetState || Object.keys(meetState.objData).length === 0) {
    return meetState.isObjLoading === false
      ? (
        <Fragment>
          <div className="row usas-extra-bottom-margin">
            <div className="col-xs-12">
              <button className={global.BackToSearchButton}
                type="button"
                onClick={onBackClicked}>
                <LeftArrowIcon />  {backToLabel}
              </button>
            </div>
          </div>
          <div className="row usas-extra-bottom-margin">
            <div className="col-xs-12">
              <PageNotFound />
            </div>
          </div>
        </Fragment>
      ) : (
        <div className="row usas-extra-bottom-margin">
          <div className="col-xs-12">
            <PopUpModal
              widthPct={50}
              maxWidth={250}
              title={Constants.LOADING_MSG}
              displayPopUp={true} />
          </div>
        </div>
      );
  }
  return (
    <Fragment>
      <div className={searchMeetState.showMeetHeader === true ? global.DisplayComponent : global.HideComponent}>
        <div className="row">
          <div className="col-xs-12">
            <button className={global.HeaderButton} onClick={onHomeClicked}>
              <Headings.H3
                className={[global.NoBottomMargin, 'col-xs-12'].join(' ')}
                excludeBar={true}>
                View/Edit Meet
              </Headings.H3>
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <hr className="usas-bar-turmeric" />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <button className={global.BackToSearchButton}
              type="button"
              onClick={onBackClicked}>
              <LeftArrowIcon />  {backToLabel}
            </button>
          </div>
        </div>
        <div className={"row"}>
          <div className="col-xs-12 col-sm-12">
            <p className={global.HeaderText}><b>Meet Name:</b> {meetCompetitionSummaryState?.objData?.meetName || ''} </p>
            <p className={global.HeaderText}><b>Meet Dates:</b> {meetCompetitionSummaryState?.isObjLoaded ? `${meetCompetitionSummaryState?.objData?.startDate ? formatDate(meetCompetitionSummaryState.objData.startDate) : ''} - ${meetCompetitionSummaryState.objData.endDate ? formatDate(meetCompetitionSummaryState.objData.endDate) : ''}` : ''}</p>
            {meetCompetitionSummaryState?.objData?.meetPacketUrl && <p className={global.HeaderText}><b>Meet Packet:</b> <a href={meetCompetitionSummaryState?.objData?.meetPacketUrl} target="_blank" rel="noreferrer">Click Here to View</a></p>}
          </div>
        </div>
        <div className="row">
          <div className="visible-xs col-xs-12">
            <MobileContextBasedNav taxonomyName="MeetDetail" />
          </div>
          <div className="hidden-xs col-xs-12">
            <LargeContextBasedNav taxonomyName="MeetDetail" homeRoute={NavLinks.MEET_INFO} />
          </div>
        </div>
      </div>
      {children}
    </Fragment>
  );
};

export default MeetContextView;